<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>

    <alert />
  </v-app>
</template>

<script>
import Alert from "@/components/alerts.component";

export default {
  name: "App",
  components: { Alert },
  data: () => ({})
};
</script>
